import { addLog } from 'assets/components/feedback/Feedback';
import ModalForm from 'assets/components/form/modalForm/ModalForm';
import ThemeModalFormDefault from 'assets/components/form/modalForm/themes/Theme.ModalForm.Default';
import { getLocales } from 'assets/locales/Locale';
import { HttpStatus } from 'config/Api.Config';
import { set } from 'lodash';
import ContractCancellationReasons from 'models/enums/ContractCancellationReasons';
import ContractCancellationTypes from 'models/enums/ContractCancellationTypes';
import ContractStatusCode from 'models/enums/ContractStatusCode';
import contractSetStatusApi from 'models/sales/contract/setStatus/Api.Contract.SetStatus';
import contractCancellationSaveApi from 'models/sales/contractCancellation/save/Api.ContractCancellation.Save';
import { SalesContractAction, useSalesContractProvider } from '../../Sales.Contract.Hooks';
import { ContractVoidCancellationForm } from '../cancellation/Contract.VoidCancellation';
import ContractRefundCancellationDetails from './tabs/Contract.RefundCancellation.Details';
import ContractRefundCancellationRefund from './tabs/Contract.RefundCancellation.Refund';

export type ContractRefundCancellationForm = ContractVoidCancellationForm;
export default function ContractRefundCancellation() {
  const { lang } = getLocales();
  const { selected, listApi, pageRouter, setIsStatusChanging } = useSalesContractProvider();

  return (
    <ModalForm<ContractRefundCancellationForm>
      subcomponents={ThemeModalFormDefault}
      dependencyArray={[selected]}
      title={lang.contractCancellation}
      default={{
        newStatus: ContractStatusCode.CANCELED_REFUND_PR_REFUND,
      }}
      onCancel={() => pageRouter.updateParams({ id: selected.id.toString(), action: SalesContractAction.INFO })}
      onSubmit={async ({ newStatus, ...data }) => {
        setIsStatusChanging(true);

        const contractStatusRes = await contractSetStatusApi(parseInt(pageRouter.params.id), {
          newStatus,
          triggerStatusFlow: true,
        });
        if (contractStatusRes.status !== HttpStatus.ok) {
          setIsStatusChanging(false);
          addLog({ error: contractStatusRes.message });
          return;
        }

        const contractCancellationRes = await contractCancellationSaveApi({
          ...data,
          type: ContractCancellationTypes.Refund,
          contract: { id: contractStatusRes.payload, statusCode: newStatus },
          contractId: contractStatusRes.payload,
        });
        if (contractCancellationRes.status !== HttpStatus.ok) {
          setIsStatusChanging(false);
          addLog({ error: contractCancellationRes.message });
          return;
        }

        addLog({ success: lang.saveSuccess });
        pageRouter.updateParams();
        setIsStatusChanging(false);
        listApi.execute((b) => b);
      }}
      validation={(data, errors) => {
        if (!data?.cancellationDateLocal) set(errors, 'cancellationDateLocal', lang.mustNotBeEmpty);
        if (!data?.odometerReading) set(errors, 'odometerReading', lang.mustNotBeEmpty);
        if (!data?.reason) set(errors, 'reason', lang.mustNotBeEmpty);
        if (data?.reason && data?.reason === ContractCancellationReasons.OTHER && !data?.reasonDescription)
          set(errors, 'reasonDescription', lang.mustNotBeEmpty);
        if (!data?.refundDateAtLocal) set(errors, 'refundDateAtLocal', lang.mustNotBeEmpty);
      }}
      isQuery={true}
      tabs={[
        {
          id: 'details',
          text: lang.details,
          errors: (props) =>
            props.form?.errors?.cancellationDateLocal ||
            props.form?.errors?.odometerReading ||
            props.form?.errors?.reason ||
            (props.form?.data?.reason === ContractCancellationReasons.OTHER && props.form?.errors?.reasonDescription),
        },
        { id: 'refund', text: lang.refund, errors: (props) => props.form?.errors?.refundDateAtLocal },
      ]}
      render={({ activeTab }) =>
        activeTab?.id === 'details' ? (
          <ContractRefundCancellationDetails />
        ) : activeTab?.id === 'refund' ? (
          <ContractRefundCancellationRefund />
        ) : null
      }
    />
  );
}
